<template>
    <div>
        <div>
            <img class="yzglpt" src="~@public/img/hotApply/icon_ehp0520.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "eHp"
    }
</script>

<style scoped>
    .yzglpt {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
</style>
